import {
  StTitleText,
  StTitleIconContainer,
  IconWrapper,
  ShareAndDownloadWrapper,
} from './FAQAccordion.style';
import Accordion from '../../components/shared/Accordion/Accordion';
import { ComponentProps } from 'lib/component-props';
import { Field, ImageField, useSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import CollapseExpandIcon from '../../components/shared/Accordion/CollapseExpandIcon';
import AboutWrapper, { ITabLinkItem } from '../../components/AboutWrapper/AboutWrapper';
import ShareAndDownload from '../../components/ShareAndDownload/ShareAndDownload';

interface AccordianItem {
  id: string;
  url: string;
  name: string;
  displayName: string;
  fields: {
    accordionTitle: Field<string>;
    accordionDescription: Field<string>;
    accordionAdditionalDescription?: Field<string>;
    autoPlayVideo: Field<boolean>;
    imageUrl?: ImageField;
    videoUrl?: {
      value?: {
        href: string;
        linktype?: string;
        url?: string;
        anchor?: string;
        target?: string;
      };
    };
  };
}

type donwloadItems = {
  value: {
    description: string;
    displayName: string;
    extension: string;
    keywords: string;
    mimeType: string;
    name: string;
    size: string;
    src: string;
    title: string;
  };
};

export type FAQAccordionProps = ComponentProps & {
  fields: {
    ShareAndDownload: {
      displayName: string;
      fields: {
        shareIcon: ImageField;
        shareText: Field<string>;
        showShareOption: Field<string>;
        sharingMedia: any;
        downloadText: Field<string>;
        downloadIcon: ImageField;
        downloadFile: ImageField;
        showDownloadOption: Field<string>;
        fileName?: donwloadItems;
      };
    };
    accordionList: Array<AccordianItem>;
    tabLinks: Array<ITabLinkItem>;
    hideExpandAllButton: Field<boolean>;
    expandAllText: Field<string>;
    expandOnlyOneAccordion: Field<boolean>;
    collapseAllText: Field<string>;
    activeTab: ITabLinkItem;
    ariaLabel: Field<string>;
    downloadFile?: any;
  };
};
const FAQAccordion = (props: FAQAccordionProps): JSX.Element => {
  const { tabLinks, activeTab } = props?.fields || {};
  const context = useSitecoreContext();

  const accordionProps = {
    expandOnlyOneAccordion: props?.fields?.expandOnlyOneAccordion
      ? props?.fields?.expandOnlyOneAccordion?.value
      : false,
    hideExpandAllButton: props?.fields?.hideExpandAllButton
      ? props?.fields?.hideExpandAllButton?.value
      : false,
    sectionsList: props.fields?.accordionList,
    expandAllText: '',
    collapseAllText: '',
  };

  return (
    <AboutWrapper tabLinks={tabLinks} activeTab={activeTab}>
      <>
        <Accordion {...accordionProps}>
          {(singleLineHeading, handleExpand, showExpandIcon, showExpandIconText) => (
            <StTitleIconContainer container justifyContent={'space-between'} alignItems={'center'}>
              <StTitleText>
                <Text
                  data-testid="page-title"
                  field={context?.sitecoreContext?.route?.fields?.pageTitle as Field<string>}
                />
              </StTitleText>

              {!accordionProps?.hideExpandAllButton && (
                <IconWrapper>
                  <>
                    <ShareAndDownloadWrapper>
                      <ShareAndDownload
                        params={{
                          pageType: 'aboutUs',
                        }}
                        fields={{
                          ...props?.fields?.ShareAndDownload?.fields,
                          downloadFile: props?.fields?.downloadFile,
                        }}
                      />
                    </ShareAndDownloadWrapper>
                    <CollapseExpandIcon
                      handleClick={handleExpand}
                      singleLineHeading={singleLineHeading}
                      showExpandIcon={showExpandIcon}
                      showExpandIconText={showExpandIconText}
                      ariaLabel={props?.fields?.ariaLabel?.value}
                    />
                  </>
                </IconWrapper>
              )}
            </StTitleIconContainer>
          )}
        </Accordion>
      </>
    </AboutWrapper>
  );
};

export default FAQAccordion;
